<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-14 17:55:36
 * @LastEditTime: 2021-06-10 16:57:24
 * @LastEditors: JDY
-->

<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-spin :spinning="loading">
        <a-form :form="form">
          <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['title', { rules: [{ required: true, message: '请输入标题' }] }]"
              placeholder="请输入标题"
            />
          </a-form-item>
          <a-form-item label="英文标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['title_en', { rules: [{ required: true, message: '请输入英文标题' }] }]"
              placeholder="请输入英文标题"
            />
          </a-form-item>
          <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
            <a-textarea
              rows="4"
              placeholder="请输入标签"
              v-decorator="['keywords', { rules: [{ required: true, message: '请输入标签' }] }]"
            />
          </a-form-item>

          <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea
              rows="4"
              name="description"
              placeholder="请输入简介"
              v-decorator="['description', { rules: [{ required: true, message: '请输入简介' }] }]"
            />
          </a-form-item>

          <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              placeholder="请选择分类"
              style="width: 100%"
              name="cat_id"
              optionFilterProp="children"
              allow-clear
              v-decorator="['cat_id', { rules: [{ required: true, message: '请选择分类' }] }]"
            >
              <a-select-option v-for="cat in categoriesList" :key="cat.id">
                {{ cat.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="考试模式" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              placeholder="请选择考试模式"
              style="width: 100%"
              name="mode_ids"
              mode="multiple"
              optionFilterProp="children"
              allow-clear
              v-decorator="['mode_ids', { rules: [{ required: true, message: '请选择考试模式' }] }]"
            >
              <a-select-option v-for="mode in modesList" :key="mode.id">
                {{ mode.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="相关课程" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              show-search
              optionFilterProp="children"
              placeholder="相关课程"
              name="course_ids"
              mode="multiple"
              allow-clear
              v-decorator="['course_ids', { rules: [{ required: true, message: '请选择相关课程' }] }]"
            >
              <a-select-option v-for="course in coursesList" :key="course.id.toString()">
                {{ course.title }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="缩略图" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <img-upload
              name="thumb"
              v-decorator="['thumb', { rules: [{ required: true, message: '请上传缩略图' }] }]"
            />
          </a-form-item>

          <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
            <u-editor
              v-decorator="['contents', { rules: [{ required: true, message: '请输入介绍' }] }]"
            />
          </a-form-item>

          <a-form-item label="证书有效期" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              name="period_of_validity"
              suffix="月"
              v-decorator="[
                'period_of_validity',
                { rules: [{ required: true, message: '请输入证书有效期' }] }
              ]"
            />
          </a-form-item>

          <a-form-item label="购买价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              name="price"
              :min="0"
              v-decorator="[
                'price',
                {
                  initialValue: 0,
                  rules: [{required: true, message: '请输入正确的价格' }]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
            <a-input-number
              name="sort"
              v-decorator="[
                'sort',
                {
                  initialValue: 0
                }
              ]"
            />
          </a-form-item>
          <a-form-item
            label="状态"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            help="是否在前端展示，默认展示"
          >
            <a-switch
              checked-children="展示"
              un-checked-children="隐藏"
              name="state"
              v-decorator="[
                'state',
                {
                  valuePropName: 'checked',
                  initialValue: true
                }
              ]"
            />
          </a-form-item>
          <a-form-item
            :wrapperCol="{
              lg: { span: 14, offset: 8 },
              md: { span: 14, offset: 8 },
              sm: { span: 14, offset: 8 },
              xs: { span: 24 }
            }"
            style="text-center: center"
          >
            <a-button
              icon="plus"
              :loading="formLoading"
              @click="handleSubmit(setFormValues)"
              type="primary"
            >提交</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { form, select } from '@/mixins' // 引入
import { ImgUpload, UEditor, GoBack } from '@/components'
import { handleSelectArr } from '@/utils/util'
const apiList = {
    getInfo: '/certificates/',
    crtsCategories: '/certificates/categories/select',
    modesList: '/certificates/modes/select',
    coursesList: '/courses/select',
    create: '/certificates/create',
    update: '/certificates/'
}

const fields = [
    'cat_id',
    'title',
    'title_en',
    'description',
    'keywords',
    'contents',
    'mode_ids',
    'price',
    'period_of_validity',
    'state',
    'thumb',
    'course_ids',
    'sort',
    'allow_buy'
]
export default {
    name: 'CrtForm',
    mixins: [form, select], // 使用mixins
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            fields,
            apiList,
            categoriesList: [], // 分类下拉数据
            categoriesLoad: false,
            modesList: [], // 分类下拉数据
            modesLoad: false,
            coursesList: [], // 分类下拉数据
            coursesLoad: false
        }
    },
    mounted () {
        this.getSelectLists({
            url: apiList.crtsCategories,
            type: 'categoriesList',
            load: 'categoriesLoad'
        })
        this.getSelectLists({
            url: apiList.modesList,
            type: 'modesList',
            load: 'modesLoad'
        })
        this.getSelectLists({
            url: apiList.coursesList,
            type: 'coursesList',
            load: 'coursesLoad'
        })
        if (this.$route.params.id) {
            this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1
                values.allow_buy = values.allow_buy === 1
                values.price = values.price / 100
                // values.course_ids = handleSelectArr(values.course_ids)
                values.mode_ids = handleSelectArr(values.mode_ids)
            })
        }
    },
    methods: {
        /**
         * 整理form表单提交数据
         * @jdy
         * @2021-4-14
         */
        setFormValues (values) {
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
            values.allow_buy = values.allow_buy ? 1 : 2 // 状态 1正常 2隐藏
        }
    }
}
</script>
